import API from '@/api'

export default {
  namespaced: true,
  state: {
    open: false,
    isNew: false,
    general: {
      info: {
        address: '',
        country: '',
        name: '',
        phone: '',
        remarks: '',
      },
      nutrients: {}
    },
    id: false,
    nutrients: []
  },
  mutations: {
    setOpen (state, flag) {
      state.open = flag;
    },
    setData (state, data) {
      state.general.info = data.lab;

      for (var item of data.methods) {
        if (!state.general.nutrients[item.type]) {
          state.general.nutrients[item.type] = [];
        }

        state.general.nutrients[item.type].push(item);
      }
    },
    addNut (state, data) {
      state.general.nutrients[data.type].push(data);
    }
  },
  actions: {
    reset ({state}) {
      state.general.info = {
        address: '',
        country: '',
        name: '',
        phone: '',
        remarks: '',
      };
      // state.general.nutrients = {};
    },
    open ({commit, state, rootGetters, dispatch}, {open, isNew = null}) {
      commit('setOpen', open);

      dispatch('setNutrients');
      if (isNew != null) {
        state.isNew = isNew;
        if (!isNew) {
          commit('setData', {lab: rootGetters['labs/lab'], methods: rootGetters['labs/methods']});
        } else {
          dispatch('reset');
        }
      }
    },
    setNutrients ({commit, state, rootGetters, dispatch}) {
      var temp = rootGetters['nutrients/topLevelNutrients'];
      state.nutrients = [];
      state.general.nutrients = {};

      for (var item of temp) {
        var res = {
          key: item.key,
          label: item.label,
          data: {
            name: '',
            type: item.key,
            lowNum: '',
            unit: 'ppm',
            highNum: '',
            adequateNum: ''
          }
        }

        state.general.nutrients[item.key] = [];
        state.nutrients.push(res);
      }
    },
    createNut ({commit, state, rootGetters, dispatch}, nut) {
      if (state.general.info.id) {
        var res = state.nutrients.find(item => item.key === nut).data;
        res.methodId = state.general.info.id;
  
        return API.labs.createExt(res).then(ret => {
          commit('addNut', ret.data.data);
          res.name = '';
          res.lowNum = '';
          res.highNum = '';
          res.adequateNum = '';

          return ret;
        });
      }
    },
    editNut ({commit, state, rootGetters, dispatch}, data) {
      var res = state.general.nutrients[data.nut].find(item => item.id === data.id);

      if (res) {
        return API.labs.updateExt(data.id, res);
      }
    },
    deleteExt ({commit, state, rootGetters, dispatch}, data) {
      var pos = state.general.nutrients[data.nut].map((item) => { 
          return item.id; 
      }).indexOf(data.id); 

      if (pos != -1) {
        return API.labs.deleteExt(data.id).then(res => {
          state.general.nutrients[data.nut].splice(pos, 1);
          
          return res;
        });
      }
    },
    //=================================================================================
    save ({commit, state, rootGetters, dispatch}) {
      if (state.isNew) {
        
        return API.labs.create(state.general.info).then(res => {
          let result = JSON.parse(JSON.stringify(res));
          if (result.data.message == "Please buy a plan!") {
            throw new Error('Please buy a plan before creating labs.')
          } else {
            state.general.info.id = res.data.data.id;
            return res;
          }
          
        })
      } else {
        
        return API.labs.update(state.general.info.id, state.general.info);
      }
    },
    //=================================================================================
    delete ({commit, state, rootGetters, dispatch}) {
      var lab = rootGetters['labs/lab'];

      return API.labs.delete(lab.id);
    }
  },
  getters: {
    open (state) {
      return state.open;
    },
    general (state) {
      return state.general;
    },
    isNew (state) {
      return state.isNew;
    },
    nutrients (state) {
      return state.nutrients;
    }
  }
}